module.exports = __webpack_public_path__ + "static/media/brand-refresh-pencil-simple.17d5e1ee.svg";